import React from 'react';

const GooglePlaySVG = () => (
  <svg
    id='Layer_2'
    data-name='Layer 2'
    xmlns='http://www.w3.org/2000/svg'
    width='28'
    height='30.444'
    viewBox='0 0 28 30.444'
  >
    <g id='OBJECTS'>
      <path
        id='Path_6639'
        data-name='Path 6639'
        d='M16.307,13.954l4.047-3.806L2.4.216A1.941,1.941,0,0,0,1.58,0Z'
        transform='translate(0.424)'
        fill='#fff'
      />
      <path
        id='Path_6640'
        data-name='Path 6640'
        d='M.241.77A1.814,1.814,0,0,0,0,1.683V28.322a1.9,1.9,0,0,0,.241.926l15.1-14.233Z'
        transform='translate(0 0.207)'
        fill='#fff'
      />
      <path
        id='Path_6641'
        data-name='Path 6641'
        d='M23.218,11.217,18.7,8.68l-4.4,4.211,4.4,4.148L23.218,14.5a1.9,1.9,0,0,0,0-3.285Z'
        transform='translate(3.84 2.331)'
        fill='#fff'
      />
      <path
        id='Path_6642'
        data-name='Path 6642'
        d='M16.307,13,1.58,26.954a1.941,1.941,0,0,0,.825-.216l17.949-9.932Z'
        transform='translate(0.424 3.491)'
        fill='#fff'
      />
    </g>
  </svg>
);
export default GooglePlaySVG;
